<template lang="pug">
	modal(:max-width="400")
		.card.text-left
			.card-header.bg-warning
				span.fa.fa-edit.mr-2
				| Editor de contenidos
				button.close(@click="cerrar") &times;
			.card-body
				.form-group
					label Emisora
					select.form-control(v-model="contenido.emisora_ID")
						option(:value="null") Genérico
						option(
							v-for="emisora in listadoEmisoras"
							:key="emisora.ID_emisora"
							:value="emisora.ID_emisora"
						) {{emisora.nombre}}
				.form-group
					label Nombre
					input.form-control(v-model="contenido.nombre")
				.form-group
					label Horario
					.input-group
						.input-group-prepend
							.input-group-text De
						input.form-control(v-model="contenido.hora_inicio", placeholder="HH:MM:SS", v-mask="'##:##:##'")
						.input-group-append
							.input-group-text a
						input.form-control.input-group-append(v-model="contenido.hora_fin", placeholder="HH:MM:SS", v-mask="'##:##:##'")
				.form-group
					label Días de la semana
					br
					.btn-group
						button.btn(
							:class="(contenido.dias_semana.indexOf(i) < 0) ? '' : 'btn-primary'"
							@click="toggleDia(i)"
							v-for="(d, i) in Array(7)"
						) {{dias[i]}}
				.form-group
					label Estado
					br
					.btn-group
						button.btn(:class="(contenido.activo) ? 'btn-success' : ''", @click="contenido.activo = true") Activo
						button.btn(:class="(!contenido.activo) ? 'btn-danger' : ''", @click="contenido.activo = false") Inactivo
			.card-footer
				button.btn.btn-primary(@click="guardar")
					span.fa.fa-save.mr-2
					| Guardar
</template>

<script>
export default {
	props: ['idContenido'],
	data () {
		return {
			contenido: {
				ID_contenido: null,
				emisora_ID: null,
				nombre: null,
				hora_inicio: null,
				hora_fin: null,
				dias_semana: [],
				activo: true
			},
			listadoEmisoras: [],
			dias: ['L', 'M', 'X', 'J', 'V', 'S', 'D']
		}
	},
	created () {
		console.log(' El ID_contenido es: ' + this.idContenido)
		if (this.idContenido && this.idContenido !== 'nuevo') {
			this.$http.get('gestion-emisoras/php/api/contenidos/get-contenido.php?ID_contenido=' + this.idContenido)
				.then(res => {
					this.contenido = res.data.contenido
				})
				.catch(this.$responseError)
		}

		this.$http.get('gestion-emisoras/php/api/emisoras/buscar-emisoras.php')
			.then(res => {
				this.listadoEmisoras = res.data.listado
			})
			.catch(this.$responseError)
	},
	methods: {
		toggleDia (dia) {
			const idx = this.contenido.dias_semana.indexOf(dia)
			if (idx < 0) {
				this.contenido.dias_semana.push(dia)
			} else {
				this.contenido.dias_semana.splice(idx, 1)
			}
		},
		guardar () {
			this.$http.post('gestion-emisoras/php/api/contenidos/set-contenido.php', this.contenido)
				.then(res => {
					this.$store.commit('toast/success', {
						titulo: 'Guardado',
						mensaje: 'Se ha guardado el contenido correctamente'
					})
					this.cerrar()
				})
				.catch(this.$responseError)
		},
		cerrar () {
			this.$emit('cerrar')
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/modulos/gestion-emisoras/vue/componentes/contenidos/editor-contenidos.vue